import PhoneVerifyViaBotScreen from '@/src/screens/PhoneVerifyViaBotScreen';

export default PhoneVerifyViaBotScreen;
